module.exports = __webpack_public_path__ + "static/media/ic-editar-azul@2x.04e01314.svg";